
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    title() {
      return {
        tag: 'h4',
        html: this.product.name,
        font: 'source'
      }
    },
    image() {
      return {
        fit: 'cover',
        ratio: '4/3',
        ...this.productImage
      }
    },
    productImage() {
      return this.product.image ? this.product.image : {}
    },
    detailsLink() {
      const products = this.$pagePath('products')
      return `${products}/${this.product.slug}`
    }
  }
}
